import { atom } from "recoil";

export const selectedOrgDashboardAtom = atom({
    key: 'selectedOrgDashboardAtom',
    default: null,
});